<template>
    <div class="schemes-container">
      <!-- <a href="http://www.msobcfdc.org/" class="link-anchor">
        Click here to go back on <span class="link">www.msobcfdc.org</span>
      </a> -->

      <!-- Search Box -->
      <div class="search-box-wrapper">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="योजना शोधा / Search Scheme..."
          class="search-input"
        />
        <i class="fa fa-search search-icon"></i>
      </div>

      <!-- Scheme Cards Grid -->
      <div class="schemes-grid">

        <!-- Scheme Card 1 - Individual Loan Interest Return Scheme -->
        <div class="scheme-card" v-show="filterScheme('Individual Loan Interest Return Scheme वैयक्तिक कर्ज व्याज परतावा योजना')">
          <h3 class="scheme-title marathi">वैयक्तिक कर्ज व्याज परतावा योजना<br><span class="english-text">Individual Loan Interest Return Scheme</span></h3>
          <div class="scheme-buttons">
            <button class="btn-eligibility" @click="showEligibility('individual-loan')">Eligibility</button>
            <button class="btn-apply" @click="applyScheme()">Apply</button>
          </div>
        </div>

        <!-- Scheme Card 2 - Group Loan Interest Return Scheme -->
        <div class="scheme-card" v-show="filterScheme('Group Loan Interest Return Scheme गट कर्ज व्याज परतावा योजना')">
          <h3 class="scheme-title marathi">गट कर्ज व्याज परतावा योजना<br><span class="english-text">Group Loan Interest Return Scheme</span></h3>
          <div class="scheme-buttons">
            <button class="btn-eligibility" @click="showEligibility('group-loan')">Eligibility</button>
            <button class="btn-apply" @click="applyScheme()">Apply</button>
          </div>
        </div>

        <!-- Scheme Card 3 - Education Loan Interest Return Scheme -->
        <div class="scheme-card" v-show="filterScheme('Education Loan Interest Return Scheme शैक्षणिक कर्ज व्याज परतावा योजना')">
          <h3 class="scheme-title marathi">शैक्षणिक कर्ज व्याज परतावा योजना<br><span class="english-text">Education Loan Interest Return Scheme</span></h3>
          <div class="scheme-buttons">
            <button class="btn-eligibility" @click="showEligibility('education-loan')">Eligibility</button>
            <button class="btn-apply" @click="applyScheme()">Apply</button>
          </div>
        </div>

        <!-- Scheme Card 4 - Direct Loan Scheme -->
        <div class="scheme-card" v-show="filterScheme('Direct Loan Scheme थेट कर्ज योजना')">
          <h3 class="scheme-title marathi">थेट कर्ज योजना<br><span class="english-text">Direct Loan Scheme</span></h3>
          <div class="scheme-buttons">
            <button class="btn-eligibility" @click="showEligibility('direct-loan')">Eligibility</button>
            <button class="btn-apply" @click="openExternalLink(' https://directscheme.sbkssavmu.msobcfdc.in/')">Apply</button>
          </div>
        </div>

        <!-- Scheme Card 5 - Seed Money Scheme -->
        <div class="scheme-card" v-show="filterScheme('Seed Money Scheme बीज भांडवल योजना')">
          <h3 class="scheme-title marathi">बीज भांडवल योजना<br><span class="english-text">Seed Money Scheme</span></h3>
          <div class="scheme-buttons">
            <button class="btn-eligibility" @click="showEligibility('seed-money')">Eligibility</button>
            <button class="btn-apply" @click="openExternalLink(' https://directscheme.sbkssavmu.msobcfdc.in/')">Apply</button>
          </div>
        </div>

      </div>

      <!-- Eligibility Modal Popup -->
      <div class="modal-overlay" v-if="showModal" @click="closeModal">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h4>Scheme Eligibility</h4>
            <button class="modal-close" @click="closeModal">&times;</button>
          </div>
          <div class="modal-body">
            <table class="eligibility-table">
              <thead>
                <tr>
                  <th>Sr No</th>
                  <th>Eligibility Criteria</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(criteria, index) in eligibilityCriteria" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{ criteria }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button class="btn-ok" @click="closeModal">OK</button>
          </div>
        </div>
      </div>

    </div>
</template>

<script>
export default {
  data() {
    return {
      searchQuery: '',
      showModal: false,
      currentScheme: '',
      eligibilityCriteria: []
    };
  },
  methods: {
    showEligibility(schemeId) {
      this.currentScheme = schemeId;
      this.eligibilityCriteria = [
        'Should be resident of Maharashtra',
        'Age limit beneficiary is Minimum 18 Years and Maximum 50 years',
        'Applicants Adhar card Link with Bank Account its Mandatory',
        'Should be registered on web portal(IR.MSOBCFDC.ORG)',
        'Beneficiary should not be a part of any other scheme under corporation',
        'Beneficiary should not be a part of any bank or financial society defaulter list',
        'Beneficiary should apply loan process in which bank having financial system application (PFMS) or any other Software application implementation for day to day transaction',
        'One person can be benefited from this scheme only once'
      ];
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    applyScheme() {
      // Navigate to registration page
      this.$router.push("/EProfile");
    },
    openExternalLink(url) {
      // Open external link in new tab
      window.open(url, '_blank');
    },
    filterScheme(schemeName) {
      if (!this.searchQuery) return true;
      return schemeName.toLowerCase().includes(this.searchQuery.toLowerCase());
    }
  },
  mounted() {
    // Initialize if needed
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Laila&display=swap");

.marathi {
  font-family: "Laila", serif;
}

.english-text {
  font-family: 'Open Sans', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  display: block;
  margin-top: 5px;
}



.link-anchor {
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  background-color: #2e4b90;
  padding: 8px 20px;
  display: block;
  width: fit-content;
  border-radius: 4px;
  margin-bottom: 20px;
  text-decoration: none;
}

.link-anchor:hover {
  background-color: #1e3a70;
  text-decoration: none;
  color: #fff;
}

/* Search Box Styles */
.search-box-wrapper {
  position: relative;
  max-width: 400px;
  margin-bottom: 25px;
}

.search-input {
  width: 100%;
  padding: 12px 45px 12px 15px;
  border: 2px solid #1565c0;
  border-radius: 25px;
  font-size: 14px;
  font-family: "Laila", serif;
  outline: none;
  transition: all 0.3s ease;
}

.search-input:focus {
  border-color: #0d47a1;
  box-shadow: 0 0 10px rgba(21, 101, 192, 0.3);
}

.search-input::placeholder {
  color: #999;
}

.search-icon {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #1565c0;
  font-size: 16px;
}

/* Card Container - New Styles */
.schemes-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 25px;
  margin: 25px 0;
}

.scheme-card {
  border: 1px solid #ccc;
  padding: 30px;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 200px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.scheme-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
}

.scheme-title {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #333;
  line-height: 1.5;
  flex-grow: 1;
}

.scheme-buttons {
  display: flex;
  gap: 15px;
  flex-wrap: wrap;
}

.btn-eligibility,
.btn-apply {
  display: inline-block;
  padding: 12px 28px;
  text-align: center;
  color: #fff !important;
  text-decoration: none;
  border-radius: 6px;
  transition: background-color 0.3s ease;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: none;
  font-family: "Open Sans", sans-serif;
}

.btn-eligibility {
  background-color: #ff9800;
}

.btn-eligibility:hover {
  background-color: #f57c00;
}

.btn-apply {
  background-color: #4caf50;
}

.btn-apply:hover {
  background-color: #388e3c;
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  width: 90%;
  max-width: 700px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background-color: #fff;
  border-bottom: 1px solid #eee;
}

.modal-header h4 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.modal-close {
  background: none;
  border: none;
  font-size: 28px;
  cursor: pointer;
  color: #999;
  line-height: 1;
}

.modal-close:hover {
  color: #333;
}

.modal-body {
  padding: 20px;
  max-height: 50vh;
  overflow-y: auto;
}

.eligibility-table {
  width: 100%;
  border-collapse: collapse;
}

.eligibility-table th,
.eligibility-table td {
  border: 1px solid #ddd;
  padding: 12px 15px;
  text-align: left;
}

.eligibility-table thead {
  background-color: #1565c0;
  color: #fff;
}

.eligibility-table th {
  font-weight: 600;
  font-size: 14px;
}

.eligibility-table th:first-child {
  width: 60px;
  text-align: center;
}

.eligibility-table td:first-child {
  text-align: center;
  font-weight: 600;
  color: #1565c0;
}

.eligibility-table tbody tr:nth-child(odd) {
  background-color: #e3f2fd;
}

.eligibility-table tbody tr:nth-child(even) {
  background-color: #fff;
}

.eligibility-table td {
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.modal-footer {
  padding: 15px 20px;
  text-align: right;
  border-top: 1px solid #eee;
}

.btn-ok {
  background-color: #1565c0;
  color: #fff;
  border: none;
  padding: 10px 30px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-ok:hover {
  background-color: #0d47a1;
}

/* Responsive Design */
@media (max-width: 992px) {
  .search-box-wrapper {
    max-width: 100%;
  }
}

@media (max-width: 576px) {
  .scheme-card {
    padding: 15px;
  }

  .scheme-title {
    font-size: 16px;
  }

  .btn-eligibility,
  .btn-apply {
    padding: 8px 16px;
    font-size: 13px;
  }

  .link-anchor {
    width: 100%;
    text-align: center;
  }

  .modal-content {
    width: 95%;
    margin: 10px;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/Portal/StatComponent2.vue